import React, { ReactNode } from 'react';
import { PageContent } from './PageContent';

interface PageProps {
  widePageContent?: boolean;
  withPageContent?: boolean;
  padding?: string;
  children: ReactNode;
}

const Page: React.FC<PageProps> = ({ children, widePageContent, padding }) => {
  return (
    <PageContent widePageContent={widePageContent} padding={padding}>
      <>{children}</>
    </PageContent>
  );
};

export default Page;
